import { createMachine } from 'xstate';

export const roundMachine = createMachine({
  id: 'hiddenCommonsRound',
  initial: 'seed',
  states: {
    seed: { on: { SPACE_READY: 'side' } },
    side: { on: { SIDE_PICKED: 'vote' } },
    vote: { on: { VOTED: 'reveal', ADD_STATEMENT: 'compose' } },
    reveal: { on: { NEXT: 'vote', ADD_STATEMENT: 'compose' } },
    compose: { on: { SUBMITTED: 'reveal', CANCEL: 'vote' } }
  }
});
